import React from 'react'
import classnames from '@helpers/misc/classnames'

export default function BigDivider({className}: {className?: string}) {
  return (
    <div
      className={classnames(
        className,
        'h-3 w-full bg-gray-100 dark:bg-zinc-600 mb-4 mt-[-8px]'
      )}></div>
  )
}
